import * as React from 'react'
import { styles } from './styles.css'

export type ButtonColor = 'primary' | 'secondary' | 'inverted' | 'bordered' | 'danger'

type Props = {
  children: React.ReactNode
  href?: string
  size?: 's' | 'm'
  color?: ButtonColor
  fluid?: boolean
  active?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement | HTMLAnchorElement>

export const FlButton: React.FC<Props> = (props) => {
  const { children, href, size = 'm', color, fluid = false, active = true, ...rest } = props
  const className = [
    styles.button,
    size === 's' ? styles.small : '',
    color ? styles[color] : '',
    fluid ? styles.fluid : '',
    active ? '' : styles.inactive,
  ].join(' ')

  if (href) {
    return (
      <a className={className} href={props.href} role="button" {...rest}>
        {props.children}
      </a>
    )
  } else {
    return (
      <button className={className} type="button" {...rest}>
        {children}
      </button>
    )
  }
}
